import { create } from 'zustand';

export type pageView =
  | 'challenges'
  | 'exercises'
  | 'hospitals'
  | 'library'
  | 'organizations'
  | 'patients'
  | 'resources'
  | 'users'
  | '';

export const searchResults = create<{
  page: pageView | undefined;
  reset: () => void;
  searchTerm: string | undefined;
  setSearchTerm: (val: string, val2: pageView) => void;
}>((set) => ({
  page: undefined,
  searchTerm: undefined,
  setSearchTerm: (term: string, searchPage: pageView) =>
    set({ searchTerm: term, page: searchPage }),
  reset: () => set({ searchTerm: undefined, page: undefined }),
}));
